import { Button, type ButtonProps, InterfaceStarFilledIcon } from '@grammarly/design-system'
import classNames from 'classnames'
import classes from './GetProButton.module.scss'

export const GetProButton = (props: Omit<ButtonProps, 'variant' | 'iconStart'>) => (
  <Button
    {...props}
    variant="pro"
    iconStart={InterfaceStarFilledIcon}
    className={classNames(classes.getProButton, props.className)}
  />
)
